<template>
  <b-popover
    ref="popover"
    target="popover-address-history"
    triggers="hover"
    placement="auto"
    container="my-container"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ 'Addresses History' }}</span>
      </div>
    </template>
    <b-card-body
      class="address-history-card-body address-scroll-div"
    >
      <app-timeline>
        <app-timeline-item
          v-for="(address, index) in addressesHistory"
          :key="index"
          variant="primary"
        >
          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6><strong>New Address:</strong></h6>
          </div>
          <p>
            {{ address.new_address }}
          </p>
          <div class="d-flex justify-content-between flex-sm-row flex-column mb-sm-0 mb-1">
            <h6><strong>Old Address:</strong></h6>
          </div>
          <p>
            {{ address.old_address }}
          </p>
          <b-media no-body>
            <b-media-body class="my-auto">
              <h6 class="media-body mb-0">
                <strong>Updated By:</strong> {{ getUpdatedBy(address) }}
              </h6>
              <h6 class="media-body mt-1 mb-0">
                <strong>Updated At:</strong> {{ ($i18n.locale === 'en') ? address.en_log_created_at : address.da_log_created_at }}
              </h6>
            </b-media-body>
          </b-media>
        </app-timeline-item>
      </app-timeline>
    </b-card-body>
  </b-popover>
</template>

<script>
import constants from '@/app-configs/constants'
import Ripple from 'vue-ripple-directive'

import {
  BPopover,
  BCardBody,
  BMedia,
  BMediaBody,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    BPopover,
    BCardBody,
    AppTimeline,
    AppTimelineItem,
    BMedia,
    BMediaBody,
  },
  directives: {
    Ripple,
  },
  props: {
    addressesHistory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      constants,
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    formattedDate(updatedBy) {
      const date = new Date(updatedBy)
      const options = {
        year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false,
      }
      const formattedDate = date.toLocaleDateString('en-US', options) // Change ',' to ' at'
      return formattedDate.replace(/, (\d{2}:\d{2})$/, ' at ')
    },
    getUpdatedBy(obj) {
      console.log('obj is ', obj)
      const str1 = obj.updated_by
      const str2 = obj.employee_name ? ` (${obj.employee_name})` : ''
      const updatedBy = str1.charAt(0).toUpperCase() + str1.slice(1) + str2
      return updatedBy
    },
  },
}
</script>

  <style lang="scss">
  .address-history-table {
    width: 100%;
    margin: 10px 0px 10px 0px;
    padding-top: 15px;
    border-top: 1px solid #f2f3f3;
  }

  .business-item {
    border-bottom: 1px solid #e1e1e1
  }

  .address-history-card-body {
    padding: 10px 0px 0px 0px;
  }

  .popover.b-popover {
    max-width: 500px;
  }

  .popover-body {
    padding: 10px 15px 20px 10px;
  }

.address-scroll-div {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 400px;
  padding-right: 10px;
}

.address-scroll-div::-webkit-scrollbar {
    width: 12px;
}

.address-scroll-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.address-scroll-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
  </style>
